import Checkbox from "@mui/material/Checkbox";
import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {withStyles} from "@mui/styles";
import classnames from "classnames";
import StatusHandler from "components/common/StatusHandler";
import {createDeepEqualSelector} from "components/common/utils";
import {ACTION_STATES} from "core/actions";
import PropTypes from "prop-types";
import React, {Component} from "react";
import {connect} from "react-redux";
import AdvTableBody from "../AdvTableBody";
import {EnhancedTableToolbar} from "../commonComponents";
import {actions as formActions} from "../logic/formActions";
import "./styles.scss";
import {useStyles} from "./tableStyles";
import Pagination from "components/common/Pagination";

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export function getSorting(order, orderBy) {
    return order === "desc" ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

export const headCells = [
    { id: "ENTERED_DATE", numeric: false, disablePadding: true, label: "Entered" },
    { id: "NAME", numeric: true, disablePadding: false, label: "Item" },
    { id: "advertisementTypeId", numeric: true, disablePadding: false, label: "Type" },
    { id: "INSTRUCTION", numeric: true, disablePadding: false, label: "Instructions" },
    { id: "protein", numeric: true, disablePadding: false, label: "Private Notes" },
];

const orderFieldsEnabled = ["ENTERED_DATE", "NAME", "INSTRUCTION"];

function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, numSelected, rowCount } = props;

    return (
        <TableHead className={classes.tableHead}>
            <TableRow style={{ display: "flex", width: "100%" }}>
                <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={numSelected === rowCount && rowCount > 0}
                        onChange={onSelectAllClick}
                        inputProps={{ "aria-label": "select all desserts" }}
                    />
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["ASC", "DESC"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

class EnhancedTable extends Component {
    state = {
        selected: [],
        page: 0,
        rowsPerPage: 10,
        dense: false,
    };

    setStateField = (field, value) => {
        this.setState({
            [field]: value,
        });
    };

    handleRequestSort = (event, property) => {
        const isDesc = this.props.orderBy === property && this.props.order === "DESC";
        this.props.changeForm([
            { attribute: "order", value: isDesc ? "ASC" : "DESC" },
            { attribute: "orderBy", value: property },
        ]);
    };

    handleClick = (event, name) => {
        const selectedIndex = this.state.selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(this.state.selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(this.state.selected.slice(1));
        } else if (selectedIndex === this.state.selected.length - 1) {
            newSelected = newSelected.concat(this.state.selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                this.state.selected.slice(0, selectedIndex),
                this.state.selected.slice(selectedIndex + 1)
            );
        }

        this.setStateField("selected", newSelected);
    };

    handleChangePage = (newPage) => {
        this.props.changeForm({ attribute: "page", value: newPage });
    };

    handleChangeRowsPerPage = (maxResults) => {
        this.props.changeForm([
            { attribute: "maxResults", value: maxResults },
            { attribute: "page", value: 0 },
        ]);
    };


    render() {
        const { dense } = this.state;
        const {
            classes,
            order,
            orderBy,
            page,
            maxResults,
            loadStatus,
            filmCompany,
            filmRelease,
            onRefresh,
            totalCount,
            loadError,
            expandAllRows,
            expandFromAllButton,
            changeExpanded,
        } = this.props;

        const loading = loadStatus === ACTION_STATES.SEND;

        const showFilm = !filmRelease;
        const showCompany = !filmRelease && !filmCompany;
        return (
            <div className={classnames(classes.root, "adv-table")} style={{ position: "relative" }}>
                <StatusHandler status={loadStatus} error={loadError} />
                {loading && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "#efefef77",
                            zIndex: 20,
                        }}
                    />
                )}
                <Paper className={classes.paper}>
                    {loading && (
                        <div className={classes.root}>
                            <LinearProgress variant="query" />
                        </div>
                    )}

                    <EnhancedTableToolbar
                        expandAllRows={expandAllRows}
                        numSelected={this.props.numSelected}
                        orderByFields={headCells.filter((headCell) =>
                            orderFieldsEnabled.find((item) => item === headCell.id)
                        )}
                        onChangeExpanded={changeExpanded}
                        onSelectField={this.handleRequestSort}
                        onRefresh={onRefresh}
                        orderBy={orderBy}
                        order={order}
                    />
                    <div className="table-wrapper">
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={dense ? "small" : "medium"}
                            aria-label="enhanced table"
                        >
                            {}
                            {}
                            {}
                            {}
                            {}
                            {}
                            {}
                            {}
                            {}
                            <AdvTableBody
                                showFilm={showFilm}
                                showCompany={showCompany}
                                expandAllRows={expandAllRows}
                                expandFromAllButton={expandFromAllButton}
                                onChangeExpanded={changeExpanded}
                                classes={classes}
                                getSorting={getSorting}
                                page={page}
                                rowsPerPage={maxResults}
                                handleClick={this.handleClick}
                                stableSort={stableSort}
                                order={order}
                                orderBy={orderBy}
                                dense={dense}
                            />
                        </Table>
                    </div>
                    <Pagination
                        rowsPerPageOptions={[25, 50, 75, 100]}
                        component={"div"}
                        count={totalCount}
                        rowsPerPage={maxResults}
                        page={page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </Paper>
            </div>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.any,
    order: PropTypes.any,
    orderBy: PropTypes.any,
    page: PropTypes.any,
    maxResults: PropTypes.any,
    loadStatus: PropTypes.any,
    filmCompany: PropTypes.any,
    filmRelease: PropTypes.any,
    onRefresh: PropTypes.any,
    totalCount: PropTypes.any,
    loadError: PropTypes.any,
    expandAllRows: PropTypes.any,
    expandFromAllButton: PropTypes.any,
    changeExpanded: PropTypes.any,
    changeForm: PropTypes.any,
    numSelected: PropTypes.any,
};

const selector = createDeepEqualSelector(
    (advertising) => advertising.form,
    (advertising) => advertising.totalCount,
    (advertising) => advertising.loadStatus,
    (advertising) => advertising.expandAllRows,
    (advertising) => advertising.expandFromAllButton,
    (advertising) => advertising.loadError,
    (advertising) => advertising.selectedAdv,
    (form, totalCount, loadStatus, expandAllRows, expandFromAllButton, loadError, selectedAdv) => {
        return {
            loadStatus,
            orderBy: form.orderBy,
            order: form.order,
            filmRelease: form.filmRelease,
            filmCompany: form.filmCompany,
            totalCount,
            maxResults: form.maxResults,
            page: form.page,
            expandAllRows,
            expandFromAllButton,
            loadError,
            numSelected: selectedAdv.length,
        };
    }
);

function mapStateToProps({ advertising }) {
    return selector(advertising);
}

function mapDispatchToProps(dispatch) {
    return {
        changeForm: (payload) => dispatch(formActions.CHANGE_FORM.send(payload)),
        onRefresh: () => dispatch(formActions.REFRESH_TABLE.send()),
        changeExpanded: (payload) => dispatch(formActions.CHANGE_EXPANDED.call(payload)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(EnhancedTable));
